import { HttpClient, HttpHeaders, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable, throwError, of, from } from 'rxjs';
import { catchError, retry, concatMap, map, switchMap, toArray } from 'rxjs/operators';
import { compressAndBatchFormData } from '../../_utils/image-compress.util';
import { isPlatformBrowser } from '@angular/common';
import { FFmpeg } from '@ffmpeg/ffmpeg';
import { fetchFile, toBlobURL } from '@ffmpeg/util';

@Injectable({
  providedIn: 'root'
})
export class PropertyService {
  private ffmpeg = new FFmpeg();
  private loaded = false;

  amenities :any =[
    { "label": "Air Conditioned", "value": "air_conditioned", "path": "M4.5 12a7.5 7.5 0 0 0 15 0m-15 0a7.5 7.5 0 1 1 15 0m-15 0H3m16.5 0H21m-1.5 0H12m-8.457 3.917l1.097-.632M16 3.518l-1.097.632M6.457 8.083l-1.097-.632M17.543 15.917l-1.097.632M9 3.518l1.097.632M8.083 17.543l.632-1.097M12 3v1.5m0 15V21m5.457-1.875l-.632-1.097M15.917 6.457l.632-1.097M8.083 6.457l-.632-1.097M17.543 8.083l1.097-.632" },
    { "label": "Banquet Hall", "value": "banquet_hall", "path": "M18 18.72a9.094 9.094 0 003.741-.479 3 3 0 00-4.682-2.72M4.5 22.5h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 004.5 22.5z" },
    { "label": "Bar / Lounge", "value": "bar_lounge", "path": "M10.5 6h9.75M10.5 10.5h9.75M10.5 15h9.75M3 12h.008v.008H3V12zm0-4.5h.008v.008H3v-.008zm0 9h.008v.008H3v-.008z" },
    { "label": "Cafeteria / Food Court", "value": "cafeteria", "path": "M20.25 7.5l-.625 10.125a3.375 3.375 0 01-3.375 3.375H7.75a3.375 3.375 0 01-3.375-3.375L3.75 7.5M10 12h4M3.375 7.5h17.25c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375C2.754 3.75 2.25 4.254 2.25 4.875v1.5c0 .621.504 1.125 1.125 1.125z" },
    { "label": "Club House", "value": "club_house", "path": "M18 18.72a9.094 9.094 0 003.741-.479 3 3 0 00-4.682-2.72M4.5 18.72a9.094 9.094 0 01-3.741-.479 3 3 0 014.682-2.72m.94 3.198l.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0112 21c2.17 0 4.207-.576 5.963-1.584A6.062 6.062 0 0116.5 15c0-1.347.437-2.592 1.177-3.598a2.25 2.25 0 113.323 3.323 6.06 6.06 0 00-1.177 3.598c0 .03.001.06.001.09a3 3 0 01-5.961-.666 11.96 11.96 0 00-1.764-.13c-.59 0-1.173.044-1.741.13a3 3 0 01-5.961.666c0-.03.001-.06.001-.09a6.06 6.06 0 00-1.177-3.598 2.25 2.25 0 113.323-3.323A6.062 6.062 0 017.5 15c0 1.347-.437 2.592-1.177 3.598z" },
    { "label": "Concierge Services", "value": "concierge", "path": "M17.982 18.725A7.488 7.488 0 0012 15.75a7.488 7.488 0 00-5.982 2.975m11.963 0a9 9 0 10-11.963 0m11.963 0A8.966 8.966 0 0112 21a8.966 8.966 0 01-5.982-2.275M15 9.75a3 3 0 11-6 0 3 3 0 016 0z" },
    { "label": "Conference Room", "value": "conference_room", "path": "M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z" },
    { "label": "DTH Facility", "value": "dth_facility", "path": "M6 20.25h12m-7.5-3v3m3-3v3m-10.125-3h17.25c.621 0 1.125-.504 1.125-1.125V4.875c0-.621-.504-1.125-1.125-1.125H3.375C2.754 3.75 2.25 4.254 2.25 4.875v10.125c0 .621.504 1.125 1.125 1.125z" },
    { "label": "Farm House", "value": "farm_house", "path": "M8.25 21v-4.875c0-.621.504-1.125 1.125-1.125h5.25c.621 0 1.125.504 1.125 1.125V21m0 0h4.5V3.545M4.5 21h4.5m0 0L6.236 6.347a4.5 4.5 0 012.012-4.041l.011-.007a4.5 4.5 0 015.484.007l.011.007a4.5 4.5 0 012.012 4.041L15 21" },
    { "label": "Fingerprint Access", "value": "fingerprint_access", "path": "M7.875 14.25l1.214 1.942a2.25 2.25 0 001.908 1.058h2.006c.776 0 1.497-.4 1.908-1.058l1.214-1.942M2.41 9h4.636a2.25 2.25 0 011.872 1.002l.164.246a2.25 2.25 0 001.872 1.002h2.092a2.25 2.25 0 001.872-1.002l.164-.246A2.25 2.25 0 0116.954 9h4.636M1.5 9.75a6.75 6.75 0 006.75 6.75h7.5a6.75 6.75 0 006.75-6.75M12 12.75v3m0 0a3 3 0 11-6 0m6 0a3 3 0 106 0" },
    { "label": "Fireplace", "value": "fireplace", "path": "M15.362 5.214A8.252 8.252 0 0112 21 8.25 8.25 0 016.038 7.048 8.287 8.287 0 009 9.6a8.983 8.983 0 013.361-6.867 8.21 8.21 0 003 2.48z" },
    { "label": "Full Glass Wall", "value": "full_glass_wall", "path": "M9 4.5v15m6-15v15m-10.5-15h15a2.25 2.25 0 012.25 2.25v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75a2.25 2.25 0 012.25-2.25z" },
    { "label": "Golf Course", "value": "golf_course", "path": "M12 21a9.004 9.004 0 008.716-6.747M12 21a9.004 9.004 0 01-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 017.843 4.582M12 3a8.997 8.997 0 00-7.843 4.582m15.686 0A11.953 11.953 0 0112 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0121 12c0 .778-.099 1.533-.284 2.253m0 0A11.952 11.952 0 0112 15c-2.998 0-5.74-1.1-7.843-2.918m15.686 2.253A8.959 8.959 0 013 12c0-.778.099-1.533.284-2.253" },
    { "label": "Gymnasium", "value": "gymnasium", "path": "M3.75 13.5l10.5-11.25L12 10.5h8.25L9.75 21.75 12 13.5H3.75z" },
    { "label": "Health Club (Steam / Jacuzzi)", "value": "health_club", "path": "M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z" },
    { "label": "Helipad", "path": "M15.59 14.37a6 6 0 01-7.18 0M4.271 8.156a8.963 8.963 0 0115.458 0M3.75 11.25a11.25 11.25 0 1122.5 0M4.5 12h15" },
    { "label": "Hilltop", "value": "hilltop", "path": "M15 11.25l-3-3m0 0l-3 3m3-3v7.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" },
    { "label": "House Help Accommodation", "value": "house_help", "path": "M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 01-7.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" },
    { "label": "Intercom Facility", "value": "intercom", "path": "M19.114 5.636a9 9 0 010 12.728M16.463 8.288a5.25 5.25 0 010 7.424M6.75 8.25l4.72-4.72a.75.75 0 011.28.53v15.88a.75.75 0 01-1.28.53l-4.72-4.72H4.51c-.88 0-1.704-.507-1.938-1.354A9.01 9.01 0 012.25 12c0-.83.112-1.633.322-2.396C2.806 8.756 3.63 8.25 4.51 8.25H6.75z" },
    { "label": "Internet / Wi-Fi", "value": "wifi", "path": "M8.288 15.038a5.25 5.25 0 017.424 0M5.106 11.856c3.807-3.808 9.98-3.808 13.788 0M1.924 8.674c5.565-5.565 14.587-5.565 20.152 0M12.53 18.22a.75.75 0 01-1.06 0L11.22 17.97a.75.75 0 011.06-1.06l.25.25a.75.75 0 010 1.06z" },
    { "label": "Island Kitchen", "value": "island_kitchen", "path": "M2.25 15a4.5 4.5 0 004.5 4.5H18a3.75 3.75 0 000-7.5h-.75M15 7.5h.008v.008H15V7.5zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z" },
    { "label": "Jogging Track", "value": "jogging_track", "path": "M15.59 14.37a6 6 0 01-7.18 0M4.271 8.156a8.963 8.963 0 0115.458 0M3.75 11.25a11.25 11.25 0 1122.5 0" },
    { "label": "Laundry Service", "value": "laundry_service", "path": "M15.75 10.5V6a3.75 3.75 0 10-7.5 0v4.5m11.356-1.993l1.263 12c.07.665-.45 1.243-1.119 1.243H4.25a1.125 1.125 0 01-1.12-1.247l1.25-12a1.125 1.125 0 011.12-1.003H18.75c.603 0 1.1.47 1.138 1.071z" },
    { "label": "Lift", "value": "lift", "path": "M8.25 15L12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9" },
    { "label": "Maintenance Staff", "value": "maintenance_staff", "path": "M11.42 15.17L17.25 21A2.67 2.67 0 0021 17.25l-5.83-5.83m-3.75 3.75a4.5 4.5 0 11-6.364-6.364 4.5 4.5 0 016.364 6.364zm11.75-11.25a2.67 2.67 0 10-3.75 3.75l.38.38-3.75 3.75-.38-.38a2.67 2.67 0 00-3.75 3.75l.38.38-3.75 3.75-.38-.38a2.67 2.67 0 00-3.75 3.75l.38.38" },
    { "label": "Outdoor Tennis Courts", "value": "tennis_courts", "path": "M21 12a9 9 0 11-18 0 9 9 0 0118 0zM12 9v6m3-3H9" },
    { "label": "Park", "value": "park", "path": "M12 21a9.004 9.004 0 008.716-6.747M12 21a9.004 9.004 0 01-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3" },
    { "label": "Piped Gas", "value": "piped_gas", "path": "M15.362 5.214A8.252 8.252 0 0112 21 8.25 8.25 0 016.038 7.048 8.287 8.287 0 009 9.6a8.983 8.983 0 013.361-6.867 8.21 8.21 0 003 2.48z" },
    { "label": "Power Backup", "value": "power_backup", "path": "M3.75 13.5l10.5-11.25L12 10.5h8.25L9.75 21.75 12 13.5H3.75z" },
    { "label": "Private Garage", "value": "private_garage", "path": "M15.75 17.25L12 21l-3.75-3.75M5.25 5.25L12 12l6.75-6.75" },
    { "label": "Private Terrace / Garden", "value": "private_terrace", "path": "M12 3v2.25m6.364.386l-1.591 1.591M21 12h-2.25m-.386 6.364l-1.591-1.591M12 18.75V21m-4.773-4.241l-1.591 1.591M3 12h2.25m.386-6.364l1.591 1.591M12 18.75V21" },
    { "label": "Private Jacuzzi", "value": "private_jacuzzi", "path": "M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z" },
    { "label": "Private Pool", "value": "private_pool", "path": "M21 12a9 9 0 11-18 0 9 9 0 0118 0z" },
    { "label": "RO Water System", "value": "ro_water", "path": "M20.893 13.393l-1.135-1.135a2.25 2.25 0 010-3.182L20.893 7.942M1.107 13.393l1.135-1.135a2.25 2.25 0 000-3.182L1.107 7.942M12 21a9 9 0 110-18 9 9 0 010 18z" },
    { "label": "Rainwater Harvesting", "value": "rainwater_harvesting", "path": "M2.25 15a4.5 4.5 0 004.5 4.5H18a3.75 3.75 0 000-7.5h-.75M15 3.56c1.106 0 2 .894 2 2s-.894 2-2 2-2-.894-2-2 .894-2 2-2z" },
    { "label": "Reserved Parking", "value": "reserved_parking", "path": "M15.75 17.25L12 21l-3.75-3.75M5.25 5.25L12 12l6.75-6.75" },
    { "label": "Sea Facing", "value": "sea_facing", "path": "M21 12a9 9 0 11-18 0 9 9 0 0118 0z" },
    { "label": "Security", "value": "security", "path": "M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.744c0 3.89 2.367 7.229 5.765 8.82a11.895 11.895 0 005.47 0C17.633 16.974 20 13.635 20 9.744c0-1.29-.203-2.532-.578-3.697A11.959 11.959 0 0112 2.714z" },
    { "label": "Service / Goods Lift", "value": "service_lift", "path": "M8.25 15L12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9" },
    { "label": "Sky Villa", "value": "sky_villa", "path": "M2.25 21h19.5m-18-18v18m10.5-18v18m6-13.5V21M6.75 6.75h.75m-.75 3h.75m-.75 3h.75m3-6h.75m-.75 3h.75m-.75 3h.75M6.75 21v-3.375c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21M3 3h12m-.75 4.5H21m-3.75 3.75h.008v.008h-.008v-.008zm0 3h.008v.008h-.008v-.008zm0 3h.008v.008h-.008v-.008z" },
    { "label": "Skydeck", "value": "skydeck", "path": "M2.25 18L9 11.25l4.306 4.307a11.95 11.95 0 015.814-5.519l2.74-1.22m0 0l-5.94-2.28m5.94 2.28l-2.28 5.941" },
    { "label": "Skyline View", "value": "skyline_view", "path": "M2.25 21h19.5m-18-18v18m10.5-18v18m6-13.5V21" },
    { "label": "Smart Home", "value": "smart_home", "path": "M9 17.25v1.007a3 3 0 01-.879 2.122L7.5 21h9l-.621-.621A3 3 0 0115 18.257V17.25m6-12V15a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 15V5.25m18 0A2.25 2.25 0 0018.75 3H5.25A2.25 2.25 0 003 5.25m18 0V12a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 12V5.25" },
    { "label": "Swimming Pool", "value": "swimming_pool", "path": "M21 12a9 9 0 11-18 0 9 9 0 0118 0z" },
    { "label": "Theme-Based Architecture", "value": "theme_architecture", "path": "M9 9l1.78 1.78m0 0l2.122 2.121m-2.122-2.121L12 6.75m-1.22 4.03L6.75 12m4.03-1.22l2.121 2.122m-2.121-2.122L11.25 15m4.03-4.03l-2.121 2.122m2.121-2.122L17.25 12m-4.03 1.22l2.122 2.121M15 11.25l-3-3m0 0l-3 3m3-3v7.5" },
    { "label": "Town House", "value": "town_house", "path": "M2.25 21h19.5m-18-18v18m10.5-18v18m6-13.5V21" },
    { "label": "Vaastu Compliant", "value": "vaastu", "path": "M15 10.5a3 3 0 11-6 0 3 3 0 016 0zM19.5 10.5a7.5 7.5 0 11-15 0 7.5 7.5 0 0115 0z" },
    { "label": "Visitor Parking", "value": "visitor_parking", "path": "M15.75 17.25L12 21l-3.75-3.75M5.25 5.25L12 12l6.75-6.75" },
    { "label": "Waste Disposal", "value": "waste_disposal", "path": "M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.053.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" },
    { "label": "Water Front", "value": "water_front", "path": "M2.25 18.75a60.07 60.07 0 0115.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75m0 10.5v.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" },
    { "label": "Water Storage", "value": "water_storage", "path": "M21 12a9 9 0 11-18 0 9 9 0 0118 0z" },
    { "label": "Wine Cellar", "value": "wine_cellar", "path": "M10.5 6h9.75M10.5 10.5h9.75M10.5 15h9.75M3 12h.008v.008H3V12zm0-4.5h.008v.008H3v-.008zm0 9h.008v.008H3v-.008z" },
    { "label": "Wrap-Around Balcony", "value": "wrap_balcony", "path": "M2.25 21h19.5m-18-18v18m10.5-18v18m6-13.5V21" },
    { 
      "label": "Security 24x7", 
      "value": "security", 
      "path": "M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.744c0 3.89 2.367 7.229 5.765 8.82a11.895 11.895 0 005.47 0C17.633 16.974 20 13.635 20 9.744c0-1.29-.203-2.532-.578-3.697A11.959 11.959 0 0112 2.714z" 
    }
  ]

  constructor(
    private http: HttpClient,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  properties(page?:number,limit?:number): Observable<any> {
    return this.http.get(`${environment.api_URL}/property?page=${page??1}&limit=${limit??20}`)
      .pipe(
        retry(1), // Retry once on failure
        catchError((error: HttpErrorResponse) => {
          // Handle server-side rendering gracefully
          if (!isPlatformBrowser(this.platformId)) {
            // console.warn('Auth request during SSR, returning empty response');
            return of({ status: false, message: 'SSR mode' });
          }
          return throwError(() => ({
            status: false,
            message: this.getErrorMessage(error),
            error: error
          }));
        })
      );
  }
  getProperty(id:any): Observable<any> {
    return this.http.get(`${environment.api_URL}/property/${id}`)
      .pipe(
        retry(1), // Retry once on failure
        catchError((error: HttpErrorResponse) => {
          // Handle server-side rendering gracefully
          if (!isPlatformBrowser(this.platformId)) {
            // console.warn('Auth request during SSR, returning empty response');
            return of({ status: false, message: 'SSR mode' });
          }
          return throwError(() => ({
            status: false,
            message: this.getErrorMessage(error),
            error: error
          }));
        })
      );
  }
  searchProperty(id:any): Observable<any> {
    return this.http.get(`${environment.api_URL}/property/propSearch?key=${id}`)
      .pipe(
        retry(1), // Retry once on failure
        catchError((error: HttpErrorResponse) => {
          // Handle server-side rendering gracefully
          if (!isPlatformBrowser(this.platformId)) {
            // console.warn('Auth request during SSR, returning empty response');
            return of({ status: false, message: 'SSR mode' });
          }
          return throwError(() => ({
            status: false,
            message: this.getErrorMessage(error),
            error: error
          }));
        })
      );
  }

  getAllAssignedAdvisor(ids:any): Observable<any> {
    return this.http.post(`${environment.api_URL}/advisor/assigendAdvisor`,{ids:ids})
      .pipe(
        retry(1), // Retry once on failure
        catchError((error: HttpErrorResponse) => {
          // Handle server-side rendering gracefully
          if (!isPlatformBrowser(this.platformId)) {
            // console.warn('Auth request during SSR, returning empty response');
            return of({ status: false, message: 'SSR mode' });
          }
          return throwError(() => ({
            status: false,
            message: this.getErrorMessage(error),
            error: error
          }));
        })
      );
  }
  findAllClusters(): Observable<any> {
    return this.http.get(`${environment.api_URL}/clusters/clustersdata`)
      .pipe(
        retry(1), // Retry once on failure
        catchError((error: HttpErrorResponse) => {
          // Handle server-side rendering gracefully
          if (!isPlatformBrowser(this.platformId)) {
            // console.warn('Auth request during SSR, returning empty response');
            return of({ status: false, message: 'SSR mode' });
          }
          return throwError(() => ({
            status: false,
            message: this.getErrorMessage(error),
            error: error
          }));
        })
      );
  }
  addClusters(clusters:any): Observable<any> {
    return this.http.post(`${environment.api_URL}/clusters/addCluster`,{clusters})
      .pipe(
        retry(1), // Retry once on failure
        catchError((error: HttpErrorResponse) => {
          // Handle server-side rendering gracefully
          if (!isPlatformBrowser(this.platformId)) {
            // console.warn('Auth request during SSR, returning empty response');
            return of({ status: false, message: 'SSR mode' });
          }
          return throwError(() => ({
            status: false,
            message: this.getErrorMessage(error),
            error: error
          }));
        })
      );
  }
  addMicroMarket(microMakert:any): Observable<any> {
    return this.http.post(`${environment.api_URL}/clusters/bulk`,{bulk:microMakert})
      .pipe(
        retry(1), // Retry once on failure
        catchError((error: HttpErrorResponse) => {
          // Handle server-side rendering gracefully
          if (!isPlatformBrowser(this.platformId)) {
            // console.warn('Auth request during SSR, returning empty response');
            return of({ status: false, message: 'SSR mode' });
          }
          return throwError(() => ({
            status: false,
            message: this.getErrorMessage(error),
            error: error
          }));
        })
      );
  }
  getAllPropertyReq(): Observable<any> {
    return this.http.get(`${environment.api_URL}/property/user/requests`)
      .pipe(
        retry(1), // Retry once on failure
        catchError((error: HttpErrorResponse) => {
          // Handle server-side rendering gracefully
          if (!isPlatformBrowser(this.platformId)) {
            return of({ status: false, message: 'SSR mode' });
          }
          return throwError(() => ({
            status: false,
            message: this.getErrorMessage(error),
            error: error
          }));
        })
      );
  }
  // addProperty(data:any): Observable<any> {
  //   return this.http.post(`${environment.api_URL}/property`,data)
  //     .pipe(
  //       retry(1), // Retry once on failure
  //       catchError((error: HttpErrorResponse) => {
  //         // Handle server-side rendering gracefully
  //         if (!isPlatformBrowser(this.platformId)) {
  //           return of({ status: false, message: 'SSR mode' });
  //         }
          
  //         // Log error for debugging
  //         console.error('Login error:', error);
          
  //         // Return a structured error response
  //         return throwError(() => ({
  //           status: false,
  //           message: this.getErrorMessage(error),
  //           error: error
  //         }));
  //       })
  //     );
  // }
  addProperty(data: any): Observable<any> {
    return this.http.post(`${environment.api_URL}/property`, data)
      .pipe(
        retry(1),
        catchError((error: HttpErrorResponse) => {
          if (!isPlatformBrowser(this.platformId)) {
            return of({ status: false, message: 'SSR mode' });
          }
  
          // 1. Extract the deep message: error.error.message
          // Your API structure: error -> error -> message
          let apiMessage = 'An unexpected error occurred';
  
          if (error.error && error.error.error && error.error.error.message) {
            // This matches your specific JSON structure
            apiMessage = error.error.error.message;
          } else if (error.error && error.error.message) {
            apiMessage = error.error.message;
          } else {
            apiMessage = error.message; // Fallback to generic HTTP error
          }
  
          // console.error('API Error:', apiMessage);
  
          return throwError(() => ({
            status: false,
            message: apiMessage, // This will now be "location should not be empty"
            originalError: error
          }));
        })
      );
  }
  updateProperty(propertyId:any,data:any): Observable<any> {
    return this.http.patch(`${environment.api_URL}/property/${propertyId}`,data)
      .pipe(
        retry(1), // Retry once on failure
        catchError((error: HttpErrorResponse) => {
          // Handle server-side rendering gracefully
          if (!isPlatformBrowser(this.platformId)) {
            // console.warn('Auth request during SSR, returning empty response');
            return of({ status: false, message: 'SSR mode' });
          }
          
          // Log error for debugging
          // console.error('Login error:', error);
          
          // Return a structured error response
          return throwError(() => ({
            status: false,
            message: this.getErrorMessage(error),
            error: error
          }));
        })
      );
  }
  

  // Compresses images in the browser, then uploads them in small batches so
  // each request stays under the server's body-size limit (avoids 413).
  // Responses are merged so callers still get one { status, message, data }.
  private uploadMediaInBatches(method: 'post' | 'patch', url: string, formData: FormData): Observable<any> {
    return from(compressAndBatchFormData(formData)).pipe(
      switchMap((batches) =>
        from(batches).pipe(
          concatMap((batch) => this.http.request<any>(method, url, { body: batch }).pipe(retry(1))),
          toArray()
        )
      ),
      map((responses: any[]) => {
        const failed = responses.find((r) => !r?.status);
        return {
          ...responses[responses.length - 1],
          status: !failed,
          message: failed ? failed.message : responses[responses.length - 1]?.message,
          data: responses.flatMap((r) => (Array.isArray(r?.data) ? r.data : [])),
        };
      })
    );
  }

  addPropertyImg(data:any): Observable<any> {
    return this.uploadMediaInBatches('patch', `${environment.api_URL}/property/${data?.id}/images?type=${data?.type}`, data.files)
      .pipe(
        catchError((error: HttpErrorResponse) => {
          if (!isPlatformBrowser(this.platformId)) {
            // console.warn('Auth request during SSR, returning empty response');
            return of({ status: false, message: 'SSR mode' });
          }
          return throwError(() => ({
            status: false,
            message: this.getErrorMessage(error),
            error: error
          }));
        })
      );
  }
  addPropertyImgAt(data:any): Observable<any> {
    return this.uploadMediaInBatches('post', `${environment.api_URL}/property/${data?.name}/images?type=${data?.type}`, data.files)
      .pipe(
        catchError((error: HttpErrorResponse) => {
          if (!isPlatformBrowser(this.platformId)) {
            // console.warn('Auth request during SSR, returning empty response');
            return of({ status: false, message: 'SSR mode' });
          }
          return throwError(() => ({
            status: false,
            message: this.getErrorMessage(error),
            error: error
          }));
        })
      );
  }
  getAllMircoMarketReq(): Observable<any> {
    return this.http.get(`${environment.api_URL}/clusters`).pipe(
      retry(1), // Retry once on failure
      catchError((error: HttpErrorResponse) => {
        // Handle server-side rendering gracefully
        if (!isPlatformBrowser(this.platformId)) {
          console.warn('Auth request during SSR, returning empty response');
          return of({ status: false, message: 'SSR mode' });
        }
        // Return a structured error response
        return throwError(() => ({
          status: false,
          message: this.getErrorMessage(error),
          error: error,
        }));
      })
    );
  }
  generatePropertyLinks(data:any): Observable<any> {
    return this.http.post(`${environment.api_URL}/property/create-links`,data)
      .pipe(
        retry(1),
        catchError((error: HttpErrorResponse) => {
          if (!isPlatformBrowser(this.platformId)) {
            // console.warn('Auth request during SSR, returning empty response');
            return of({ status: false, message: 'SSR mode' });
          }
          return throwError(() => ({
            status: false,
            message: this.getErrorMessage(error),
            error: error
          }));
        })
      );
  }
  getAmenities = () => {
    return this.amenities
  }

  deleteImage(propertyId: string, imageUrl: string,type:string): Observable<any> {
    const params = new HttpParams().set('url', imageUrl).set('imgType', type);
    return this.http.delete(`${environment.api_URL}/property/propertyImg/${propertyId}`, { params }).pipe(
      catchError(this.handleError)
    );
  }

  deleteProperty(propertyId: string, deleteReason:any): Observable<any> {
    return this.http.delete(`${environment.api_URL}/property/${propertyId}`,{ body: { deleteReason }}).pipe(
      catchError(this.handleError)
    );
  }
 

  private handleError(error: HttpErrorResponse) {
    let errorMessage = 'An unknown error occurred!';
    
    if (error.error instanceof ErrorEvent) {
      // Client-side error
      errorMessage = `Errorsss: ${error.error.message}`;
    } else {
      // Server-side error
      errorMessage = error.error?.message || `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    
    console.error(errorMessage);
    return throwError(() => new Error(errorMessage));
  }

  getYearRange(offset: number = 10): string[] {
    const currentYear = new Date().getFullYear();
    const years: string[] = [];
  
    // Loop from (current - offset) to (current + offset)
    for (let i = currentYear - offset; i <= currentYear + offset; i++) {
      years.push(i.toString());
    }
  
    return years;
  }

  private getErrorMessage(error: HttpErrorResponse): string {
    // If the error is a string (rare), return it
    if (typeof error.error === 'string') return error.error;
  
    // Check the deep nested path from your specific API response
    if (error.error?.error?.message) {
      return error.error.error.message;
    }
  
    // Check the standard nested path
    if (error.error?.message) {
      return error.error.message;
    }
    // Fallback
    return `Error Code: ${error.status}\nMessage: ${error.message}`;
  }
  formatBuildingStr(input: any): string {
    if (!input) return '—';
    const clean = input.trim().replace(/[,+]+/g, ' ').replace(/\s+/g, ' ').toUpperCase();
    const parts = clean.split(' ').filter((p:any) => p.length > 0);
  
    if (parts.length === 0) return '—';
    if (parts.length === 1) return parts[0];
    return parts.join(' + ');
  }
  
  async loadFFmpeg() {
      if (this.loaded) return;
      
      const baseURL = 'https://unpkg.com/@ffmpeg/core@0.12.6/dist/umd';
      await this.ffmpeg.load({
        coreURL: await toBlobURL(`${baseURL}/ffmpeg-core.js`, 'text/javascript'),
        wasmURL: await toBlobURL(`${baseURL}/ffmpeg-core.wasm`, 'application/wasm'),
      });
      this.loaded = true;
  }
  
  async addWatermark(videoFile: File, logoPath: string): Promise<Blob> {
      await this.loadFFmpeg();
  
      const inputName = videoFile.name;
      const outputName = `output_${Date.now()}.mp4`;
  
      // 1. Write files to FFmpeg Virtual File System
      await this.ffmpeg.writeFile(inputName, await fetchFile(videoFile));
      await this.ffmpeg.writeFile('logo.png', await fetchFile(logoPath));
  
      // 2. Execute Command
      // Sets logo to 30% width and centers it
      await this.ffmpeg.exec([
        '-i', inputName,
        '-i', 'logo.png',
        '-filter_complex', '[1:v]scale=iw*0.30:-1[wm];[0:v][wm]overlay=(main_w-overlay_w)/2:(main_h-overlay_h)/2',
        '-codec:a', 'copy',
        outputName
      ]);
  
      // 3. Read the result
      const data = await this.ffmpeg.readFile(outputName);
      return new Blob([data], { type: 'video/mp4' });
  }
}
